<template>
  <div class="comingsoon" v-if="client">
    <div class="side">
      <img @click="goTo('/')" class="logo" :src="client.logo" />
      <h2>{{ our_community.title }}</h2>
      <p>{{ our_community.description }}</p>
    </div>

    <div class="rightside" v-if="our_community">
      <template v-if="our_community.images && our_community.images.length">
        <slider
          ref="slider"
          v-if="show_images"
          :slides="our_community.images"
          :in_page_slidehow="true"
          :show_text="false"
        ></slider>
      </template>
      <template v-else>
        <div class="gallery no-listings">
          <img src="@/assets/img/no-photo.svg" />
          <p>There are currently no new listings</p>
        </div>
      </template>

      <div class="testimonials">
        <div class="controls" v-if="our_community.testimonials.length > 2">
          <img class="flip left" @click="navigate(-1)" src="@/assets/img/next.svg" />
          <img class="right" @click="navigate(1)" src="@/assets/img/next.svg" />
        </div>
        <h3 :style="{ color: our_community.font_color + ' !important' }">Testimonials</h3>
        <carousel
          :perPage="2"
          :loop="true"
          navigationNextLabel=">"
          :navigateTo="current_index"
          :autoplay="true"
          :autoplayTimeout="10000"
        >
          <slide v-for="(testimonial, i) in our_community.testimonials">
            <div class="testimonial">
              <img src="@/assets/img/quote.svg" />
              <p>
                {{ testimonial.description }}
                <span>– {{ testimonial.name }}</span>
              </p>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions, analytics } from "@/config/firebaseInit";
import { Carousel, Slide } from "vue-carousel";
import Slider from "@/components/Slider";

export default {
  name: "home",
  components: {
    Slider,
    Carousel,
    Slide
  },
  data() {
    return {
      client: this.$store.state.client,
      user: this.$store.state.user,
      our_community: this.$store.state.our_community,
      show_images: true,
      current_index: 0
    };
  },
  mounted() {},
  async created() {},
  watch: {},
  methods: {
    showImages(index) {
      this.show_images = true;
      setTimeout(() => {
        this.$refs.slider.current_index = index;
      }, 100);
    },
    navigate(direction) {
      if (
        this.current_index == this.our_community.testimonials.length &&
        direction == 1
      ) {
        this.current_index = 0;
      } else if (this.current_index == 0 && direction == -1) {
        this.current_index = this.our_community.testimonials.length - 1;
      } else {
        this.current_index = this.current_index + direction;
      }
    }
  }
};
</script>

<style lang="scss">
.comingsoon {
  height: 100vh;
  width: 100vw;
  display: flex;
  .side {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 500px;
    padding: 100px;
    flex: none;
    .logo {
      width: 275px;
      margin: auto;
      margin-top: 50px;
      margin-bottom: 30px;
    }
    h2 {
      color: black;
      font-size: 51px;
      margin-bottom: 0;
    }
    p {
      font-size: 23px;
    }
  }
  .rightside {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 50px;
    padding-right: 50px;
  }
  .gallery.no-listings {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    min-height: 700px;
  }
}

.testimonials {
  display: flex;
  flex-wrap: wrap;
  padding-top: 50px;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  position: relative;
  .controls {
    img {
      top: 50%;
      position: absolute;
      filter: brightness(0) invert(1);
      z-index: 10;
      left: -55px;
      height: 75px;
      opacity: 0.3;
      padding: 20px;
      box-sizing: border-box;
      &.flip {
        transform: scaleX(-1);
      }
      &.right {
        left: auto;
        right: -55px;
      }
    }
  }
  .VueCarousel {
    width: 100%;
  }
  .VueCarousel-wrapper,
  .VueCarousel-inner {
    height: 100%;
  }
  h3 {
    color: black;
    width: 100%;
    font-size: 40px;
    text-align: center;
    margin-bottom: 0;
  }
  .VueCarousel-slide {
    padding: 20px;
    box-sizing: border-box;
  }
  .testimonial {
    display: flex;
    align-items: flex-start;
    width: 100%;
    background: #f7f7f7;
    padding: 30px;
    height: 250px;
    img {
      height: 50px;
      opacity: 0.2;
    }
    p {
      margin-left: 30px;
      font-size: 23px;
      span {
        display: block;
        font-size: 17px;
        margin-top: 10px;
      }
    }
  }
}
</style>
